<template>
  <section class="section">
    <div class="container">
      <div class="cr_wrapper">
        <div class="feature_image">
          <img
            class="img-fluid"
            alt=""
            :src="require('../assets/images/registration-02.png')"
          />
        </div>
        <div class="cr_item">
          <div class="cr_item_content" v-if="!isForgetPassword">
            <h1>Trainer Dashboard</h1>
            <h2>Login to your account</h2>
            <!--            <h2>or <a href="/register">Get started with Upskill!</a></h2>-->
            <ul class="cr_steps" style="width: 100%;">
              <li class="active"></li>
            </ul>
            <uform style="max-width: 600px">
              <ulabel size="12">
                <uinput placeholder="Email*" v-model="model.email" @keypress.native.enter="login"></uinput>
              </ulabel>
              <ulabel size="12">
                <uinput
                  placeholder="Password*"
                  type="password"
                  @keypress.native.enter="login"
                  v-model="model.password"
                ></uinput>
              </ulabel>
              <ulabel size="6">
                <ubtn
                  class="mx-auto"
                  @click.prevent.native="login"
                  :loading="btnLoading"
                  >Login</ubtn
                >
              </ulabel>
              <ulabel size="6">
                <ubtn
                  color="white"
                  textColor="black"
                  @click.native.prevent="isForgetPassword = true"
                  >Forgot your password?</ubtn
                >
              </ulabel>
            </uform>
          </div>
          <div  style="margin-left: 5px; margin-top:50px;">Don't have a trainer account? <a href="/register/trainer">Create a trainer profile by clicking here</a></div>
          <div class="cr_item_content" v-if="isForgetPassword">
            <h1>Please write down the email you've used for registration</h1>
            <!--            <h2>or <a href="/register">Get started with Upskill!</a></h2>-->
            <ul class="cr_steps" style="width: 100%;">
              <li class="active"></li>
            </ul>
            <uform style="max-width: 600px">
              <ulabel size="12">
                <uinput placeholder="Email*" v-model="fp_email"></uinput>
              </ulabel>
              <ulabel size="6">
                <ubtn
                  class="mx-auto"
                  @click.prevent.native="fpSubmit"
                  :loading="btnLoading"
                  >Submit</ubtn
                >
              </ulabel>
              <ulabel size="6">
                <!--                <ubtn color="white" textColor="black"-->
                <!--                  >Forgot your password?</ubtn-->
                <!--                >-->
              </ulabel>
            </uform>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      model: {},
      form: {},
      btnLoading: false,
      loading: false,
      fp_email: "",
      isForgetPassword: false
    };
  },
  methods: {
    login() {
      this.btnLoading = true;
      this.$upskill
        .loginConsultant(this.model)
        .then(res => {
          this.btnLoading = false;
          localStorage.setItem("ctoken", res.data.token);
          this.SuccessAlert("Login successful!")
          this.$router.push({name: "test"})
        })
        .catch(() => {
          this.btnLoading = false;
          this.ErrorAlert("Invalid credentials!");
        });
    },
    validateEmail() {
      var re = /\S+@\S+\.\S+/;
      return re.test(this.form.email);
    },
    signup() {
      this.SetFirstTimer()
      this.loading = true;
      if (
        !this.form.phone ||
        !this.form.email ||
        !this.form.password ||
        !this.form.name
      ) {
        this.ErrorAlert("Please fill up all the fields");
        this.loading = false;
      } else if (this.form.phone.length != 11) {
        this.ErrorAlert("Provide a valid phone number");
        this.loading = false;
      } else if (!this.validateEmail()) {
        this.ErrorAlert("Provide a valid email");
        this.loading = false;
      } else if (!this.form.password.length > 7) {
        this.ErrorAlert("Password must contain at least 8 characters");
      } else {
        // console.log("triggered");
        this.siteRegister();
      }
    },
    siteRegister() {
      let validResponse = false;
      this.$upskill
        .oldRegister(this.form)
        .then(res => {
          // this.SetFirstTimer()
          validResponse = true;
          this.loading = false;
          localStorage.removeItem("token");
          localStorage.setItem("token", res.data.token);
          let pw = localStorage.getItem("pendingWorkshop");
          if (pw) {
            this.TimerAlert(
              "Please wait...",
              "We are registering you for the workshop!",
              1000
            );
            this.loading = true;
            this.joinWorkshop(pw);
          } else {
            this.SuccessAlert("Registration successful!");
            this.Goto({ name: "home" });
            this.loading = false;
          }
        })
        .catch(error => {
          this.loading = false;
          if (!validResponse) {
            this.ErrorAlert(error.response.data.message);
          }
        });
    },
    joinWorkshop(id) {
      localStorage.removeItem("pendingWorkshop");
      this.$upskill
        .join(id)
        .then(() => {
          this.loading = false;
          this.SuccessAlert("You are registered for the workshop. Please complete the purchase by clicking the pay button (ignore if the workshop is free)");
          this.GotoWS(id);
          // this.GotoProfile()
        })
        .catch(() => {
          this.loading = false;
          this.Goto({ name: "thanks" });
          this.GotoWS(id);
          // this.GotoProfile()
        });
    },
    fpSubmit() {
      this.btnLoading = true;
      this.$upskill
        .pwInit(this.fp_email)
        .then(() => {
          this.btnLoading = false;
          this.SuccessAlert(
            "An email has been sent your inbox! Please check for further instructions."
          );
          this.isForgetPassword = false;
        })
        .catch(() => {
          this.btnLoading = false;
          this.SuccessAlert(
            "An email has been sent your inbox! Please check for further instructions."
          );
          this.isForgetPassword = false;
        });
    }
  },
  created() {
    this.Loaded();
  }
};
</script>

<style scoped>
.signup {
  margin-top: 25px;
  background: #013686 0% 0% no-repeat padding-box;
  display: flex;
  padding: 20px;
  flex-wrap: wrap;
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
}
.form_input {
  width: 100%;
  height: 38px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #728391;
  opacity: 1;
  padding: 10px;
  font-family: "Montserrat", sans-serif;
  margin: 5px 0px;
}
label {
  color: #999;
  font-size: 12px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 10px;
  top: -14px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}
.group {
  position: relative;
  width: 100%;
  margin-top: 20px;
}
.signin-title {
  margin-left: auto;
  margin-right: auto;
  font-family: "Montserrat", sans-serif;
  font-size: 30px;
  letter-spacing: 4px;
  /*letter-spacing: -2.5px;*/
  color: #fff;
}
</style>
